import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t&:not([disabled]) {\n\t\t&:hover {\n\t\t\t", " {\n\t\t\t\toutline: 1px solid rgba(255, 0, 0, 0.12);\n\t\t\t}\n\t\t}\n\n\t\t", " {\n\t\t\t&:hover {\n\t\t\t\toutline: 1px solid rgba(0, 180, 255, 0.2) !important;\n\n\t\t\t\t", " {\n\t\t\t\t\toutline: 1px solid rgba(0, 180, 255, 0.2) !important;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\toutline: 1px solid rgba(0, 180, 255, 0.3) !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { cns, ns } from '@wp-g2/context';
import { styled } from '@wp-g2/styles';

var _Object$keys = Object.keys(cns()),
    _Object$keys2 = _slicedToArray(_Object$keys, 1),
    CONNECTED_NAMESPACE = _Object$keys2[0];

var _Object$keys3 = Object.keys(ns()),
    _Object$keys4 = _slicedToArray(_Object$keys3, 1),
    NAMESPACE = _Object$keys4[0];

var connectedComponentSelector = "[" + CONNECTED_NAMESPACE + "]:not([" + NAMESPACE + "='Debugger']):not([" + NAMESPACE + "='ComponentInspector'])";
var namespacedComponentSelector = "[" + NAMESPACE + "]:not([" + NAMESPACE + "='Debugger']):not([" + NAMESPACE + "='ComponentInspector'])";
export var ComponentInspectorView = styled.div(_templateObject(), namespacedComponentSelector, connectedComponentSelector, connectedComponentSelector);